// extracted by mini-css-extract-plugin
module.exports = {"notFoundRow":"Unauthorize_notFoundRow_3w0zf","logo":"Unauthorize_logo_3K966"};